// 用户相关文案
export default {
  login: 'Sign in',
  logout: 'Sign Out',
  logoutTip: 'Are you sure you want to sign out?',
};
